const api = process.env.API_URL;

export default {
  version: "1.0.3",
  base: process.env.BASE || '',
  api_url: api,
  storage: `${api}/storage`,
  siteName: '武蔵境自動車教習所 オンライン学科【オンデマンド配信】',
}
